import { Component, OnInit } from '@angular/core';
import { logo } from 'src/assets/logo';
@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit {
  logo;
  constructor() { }

  ngOnInit() {
    this.logo = logo;
  }

}
